import axios from 'axios';
import { URL_COUNTRIES_LIST } from './config';

export async function getCountriesList() {
    const result = await axios.get(URL_COUNTRIES_LIST);
    return result.data.data;
};

